import { AppState } from '../rootReducer';
import { DayBookNotesList } from './types';

export const getDayBookNotes = (state: AppState): DayBookNotesList => state.dayBook.notesList;
